<template>
  <div id="app">
    <FreeResources v-if="resources" />
    <ResearchReports v-if="reports" />
    <OnlineLearning v-if="learning" />
  </div>
</template>

<script>


import FreeResources from './components/FreeResources.vue'
import ResearchReports from './components/ResearchReports.vue'
import OnlineLearning from './components/OnlineLearning.vue'

export default {
  name: 'App',
  components: {
    FreeResources,
    ResearchReports,
    OnlineLearning

  },
  data() {
    // These values control which component is displayed on the page. Set the one you want to true and the others to false.
    return {
      reports: false,
      resources: true,
      learning: false
    }
  },
  mounted: function () {
    // document.cookie = "pll_language=fr";

  },
}
</script>

<style></style>
